import React, { useState } from 'react';
import Cookies from 'js-cookie';
import {
  Dialog,
  Typography,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Button,
  RadioGroup,
  Radio,
} from '@mui/material';
import { ILoader } from '~/_base/components/helixIcons';
import { useToast } from '~/_base/context/toastContext';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

type Props = {
  onSave: () => void;
  onClose: () => void;
  open: boolean;
  id: number | null;
};

export default function LocalesDialog(props: Props) {
  const { warningToast, successToast } = useToast();
  const [saving, setSaving] = useState(false);
  const localeFromCookie = Cookies.get('locale');
  const localeFromBrowser = navigator.language.split('-')[0];
  const currentLocale = localeFromCookie || localeFromBrowser;
  const [selectedLocale, setSelectedLocale] = useState(currentLocale);
  const { i18n, t } = useTranslation();
  const languageValues = [
    { value: 'en', label: t('English') },
    { value: 'en-US', label: t('English (US)') },
    { value: 'es', label: t('Spanish') },
    { value: 'fr', label: t('French') },
  ];

  function saveChange() {
    setSaving(true);
    if (selectedLocale) {
      Cookies.set('locale', selectedLocale);
      i18n.changeLanguage(selectedLocale);
      moment.locale(selectedLocale);
      successToast(t('Language updated!'));
      setSaving(false);
      props.onSave();
    } else {
      setSaving(false);
      warningToast(t('Please select a language to proceed.'));
    }
  }

  return (
    <Dialog
      data-testid="locales_dialog"
      open={props.open}
      onClose={e => {
        props.onClose();
      }}
      slotProps={{
        paper: {
          sx: {
            width: '90vw',
            maxWidth: '600px',
            height: '45vh',
            maxHeight: '400px',
          }
        }
      }}
    >
      <DialogTitle sx={{ px: 0, pb: 0 }}>
        <Typography variant="h3" sx={{ px: 3, pb: 0 }}>
          {t('Change language')}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ borderTop: '1px solid #e6eaec', marginTop: '-1px' }}>
        <RadioGroup
          sx={{ mb: 1 }}
          name="locales_available"
          value={selectedLocale}
          onChange={(e, val) => {
            setSelectedLocale(val);
          }}
        >
          {languageValues.map(lang => (
            <FormControlLabel
              key={lang.value}
              value={lang.value}
              control={<Radio />}
              label={lang.label}
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={e => {
            props.onClose();
          }}
        >
          {t('Cancel')}
        </Button>
        <Button
          sx={{ minWidth: '100px' }}
          startIcon={
            saving && (
              <ILoader fontSize="small" />
            )
          }
          variant="contained"
          color="primary"
          onClick={e => saveChange()}
        >
          {t('Save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

